import React, { useState } from 'react';
import Styled from 'styled';

import defaultStyles from './slider.scss';

interface Props {
    styles: typeof defaultStyles;
    label?: string | JSX.Element;
    checked?: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Slider: React.FC<Props> = props => {
    const { styles, label, checked: checkedProps = false, onChange } = props;
    const [checked, setChecked] = useState<boolean>(checkedProps);
    return (
        <div className={styles.wrapper}>
            <label className={styles.switch}>
                <input
                    type={'checkbox'}
                    className={styles.sliderInput}
                    onChange={event => {
                        setChecked(!checked);
                        onChange(event);
                    }}
                    checked={checked}
                />
                <span className={styles.slider} />
            </label>
            {label ? <span>{label}</span> : null}
        </div>
    );
};

export default Styled(defaultStyles)(Slider);
